import { SvgGraphicProps, SvgGraphic } from "../atoms";
import React from "react";

export const Checkmark = (props: SvgGraphicProps) => (
  <SvgGraphic viewBox="0 0 80 65" fill-rule="evenodd" clip-rule="evenodd" {...props}>
    <polygon fill="currentColor" points="0,38 10,25 36,47 78,0 90,11 37,69 "/>
  </SvgGraphic>
)
